var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"form-control-label"},[_vm._v(_vm._s(_vm.element.text))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.element.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }